module.exports = __webpack_public_path__ + "static/media/DMZ3.167acd59.webp";